import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SurveyCreationAudienceEffects } from './state/audience/survey-creation-audience.effects';
import { SurveyAudienceCreateEffects } from './state/audience/survey-audience-create.effects';
import { SurveyCreationTemplateEffects } from './state/audience/survey-creation-template.effects';
import { SurveyCreationMcTemplateEffects } from './state/audience/survey-creation-mc-template.effects';
import { SurveyCreationTrackerTemplateEffects } from './state/audience/survey-creation-tracker-template.effects';
import { SurveyCreationTemplateSaveEffects } from './state/audience/survey-creation-template-save.effects';
import { SurveyCreationConfirmationEffects } from './state/audience/survey-creation-confirmation.effects';
import { SurveyCreationLocaleChangeEffects } from './state/audience/survey-creation-locale-change.effects';
import { SurveyCreationDeprecatedQualificationsOnLoadEffects } from './state/audience/survey-creation-deprecated-qualifications-on-load.effects';
import { SurveyCreationCoreEffects } from './state/core/survey-creation-core.effects';
import { SurveyCreationTrackerEffects } from './state/core/survey-creation-tracker.effects';
import { SurveyCreationSaveEffects } from './state/core/survey-creation-save.effects';
import { SurveyCreationUnsavedMcChildSaveEffects } from './state/core/survey-creation-unsaved-mc-child-save.effects';
import { SurveyCreationMcSaveEffects } from './state/audience/survey-creation-mc-save.effects';
import { SurveyCreationTrackerSaveEffects } from './state/audience/survey-creation-tracker-save.effects';
import { SurveyCreationChildrenEffects } from './state/core/survey-creation-children.effects';
import { SurveyCreationWorkflowExitEffects } from './state/core/survey-creation-workflow-exit.effects';
import { SurveyCreationAdvancedFiltersEffects } from './state/insights/survey-creation-advanced-filters.effects';
import { SurveyCreationEpcEffects } from './state/insights/survey-creation-epc.effects';
import { SurveyCreationInsightsEffects } from './state/insights/survey-creation-insights.effects';
import { SurveyCreationSimilarSurveyInsightEffects } from './state/insights/survey-creation-similar-survey-insight.effects';
import { SurveyCreationImprobableQuotaEffects } from './state/insights/survey-creation-improbable-quota.effects';
import { SurveyCreationApplyOfferPriceEffects } from './state/insights/survey-creation-apply-offer-price.effects';
import { SurveyCreationReferenceEffects } from './state/reference/survey-creation-reference.effects';
import { SurveyCreationLaunchEffects } from './state/launch/survey-creation-launch.effects';
import { SurveyCreationRespondentListEffects } from './state/launch/survey-creation-respondent-list.effects';
import { SurveyCreationLaunchAudienceFiltersEffects } from './state/launch/survey-creation-launch-audience-filters.effects';
import { SurveyCreationLaunchActivityLogEffects } from './state/launch/survey-creation-launch-activity-log.effects';
import { SurveyCreationTestEntryLinkEffects } from './state/launch/survey-creation-test-entry-link.effects';
import { SurveyCreationLaunchSubmitEffects } from './state/launch/survey-creation-launch-submit.effects';
import { SurveyCreationLaunchLocaleSyncEffects } from './state/launch/survey-creation-launch-locale-sync.effects';
import { surveyCreationFeature } from './state/survey-creation.feature';

export const SURVEY_CREATION_STORE_PROVIDERS = {
  feature: provideState(surveyCreationFeature),
  effects: provideEffects(
    SurveyCreationAudienceEffects,
    SurveyAudienceCreateEffects,
    SurveyCreationTemplateEffects,
    SurveyCreationMcTemplateEffects,
    SurveyCreationTrackerTemplateEffects,
    SurveyCreationTemplateSaveEffects,
    SurveyCreationCoreEffects,
    SurveyCreationTrackerEffects,
    SurveyCreationSaveEffects,
    SurveyCreationUnsavedMcChildSaveEffects,
    SurveyCreationMcSaveEffects,
    SurveyCreationTrackerSaveEffects,
    SurveyCreationChildrenEffects,
    SurveyCreationWorkflowExitEffects,
    SurveyCreationConfirmationEffects,
    SurveyCreationLocaleChangeEffects,
    SurveyCreationDeprecatedQualificationsOnLoadEffects,
    SurveyCreationInsightsEffects,
    SurveyCreationAdvancedFiltersEffects,
    SurveyCreationSimilarSurveyInsightEffects,
    SurveyCreationImprobableQuotaEffects,
    SurveyCreationApplyOfferPriceEffects,
    SurveyCreationEpcEffects,
    SurveyCreationReferenceEffects,
    SurveyCreationLaunchEffects,
    SurveyCreationRespondentListEffects,
    SurveyCreationLaunchAudienceFiltersEffects,
    SurveyCreationLaunchActivityLogEffects,
    SurveyCreationTestEntryLinkEffects,
    SurveyCreationLaunchSubmitEffects,
    SurveyCreationLaunchLocaleSyncEffects,
  ),
};
